module.exports = __webpack_public_path__ + "static/009_Room-366410bd1ea635c7a37fe7a252523fac.jpg";